import type { SchemaField } from '@cli-types/core-engine/schema.js'
export function buildExplicitSelect(
  fields: SchemaField[],
  tableVar: string,
  htmlFields: SchemaField[] = [],
  extraSelects: string[] = [],
  extraJoins = ''
): string {
  const fieldSelects = fields.map((f) => `      ${f.name}: ${tableVar}.${f.name}`)
  const htmlSelects = htmlFields.map((f) => `      ${f.name}Html: ${tableVar}.${f.name}Html`)
  const selects = [...fieldSelects, ...htmlSelects, ...extraSelects].join(',\n')
  return `db.select({\n${selects}\n    }).from(${tableVar})${extraJoins}`
}
